export default ( event, currencyCode, id, name, price, brand, category, variant, position, balance, user ) => {
  let userProfile = null;
  let clubpremierIDP = null;
  let pointsCP = null;
  let metricPointsValue = 0;

  if (user !== undefined) {
    userProfile = user.userProfile;
  }

  if (userProfile !== null) {
    clubpremierIDP = userProfile.ffNumber;
    pointsCP = userProfile.account.balance;
  }
  
  if (balance !== null) {
    metricPointsValue = price.totalCPPoints;
  }

  return clubpremierIDP !== null ? {
    event: event,
    ticketNumber: '',
    pointsValue: metricPointsValue,
    pointsCP: pointsCP,
    clubpremierIDP: clubpremierIDP,
    ecommerce: {
      currencyCode: currencyCode,
      impressions: [{
        id: id,
        name: name,
        price: `${price.total ? price.total : price}`,
        brand: brand,
        category: category,
        variant: variant,
        position: position,
      }],
    },
  } : {
    event: event,
    ecommerce: {
      currencyCode: currencyCode,
      impressions: [{
        id: id,
        name: name,
        price: `${price.total ? price.total : price}`,
        brand: brand,
        category: category,
        variant: variant,
        position: position,
      }],
    },
  };
};